import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getAccount } from '@littlebooker/dal';
import { useAuth } from '@/contexts/AuthContext';
import { type CountryCode } from 'react-phone-number-input';

/**
 * Hook to get the default country code from account settings
 * Falls back to 'NL' (Netherlands) if not set
 */
export function useDefaultCountry(): CountryCode {
  const { account } = useAuth();
  
  const { data: accountData } = useQuery({
    queryKey: ['account', account?.id],
    queryFn: () => (account?.id ? getAccount(account.id) : null),
    enabled: !!account?.id,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });

  return useMemo(() => {
    if (accountData?.settings && typeof accountData.settings === 'object') {
      const settings = accountData.settings as Record<string, unknown>;
      if (settings.default_country_code && typeof settings.default_country_code === 'string') {
        return settings.default_country_code as CountryCode;
      }
    }
    return 'NL'; // Default to Netherlands
  }, [accountData?.settings]);
}



